import React from 'react'

const Vue = ({size=80, ...props}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 80 80" fill="none" {...props} xmlns="http://www.w3.org/2000/svg"><path d="M49.25 6.25 40 22.125 30.75 6.25H0L40 75 80 6.25H49.25Z" fill="#42B883"/><path d="m49.248 6.25-9.25 15.875-9.25-15.875h-14.75l24 41.25 24-41.25h-14.75Z" fill="#35495E"/></svg>
  )
};

export default Vue
